import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class PermissionService extends Token {
  
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "permission",
      withCredentials: true,
    }).then((res) => res.data);
  }
}
